document.addEventListener('DOMContentLoaded', () => {
  function updateAllCartBubbles() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const count = cart.item_count || 0;

        document.querySelectorAll(
          '[data-shogun-cart-items-count] .cart-count-bubble span[aria-hidden="true"]'
        ).forEach(span => {
          span.textContent = count;
        });

        document.querySelectorAll(
          '[data-shogun-cart-items-count] .cart-count-bubble .visually-hidden'
        ).forEach(el => {
          el.textContent = el.textContent.replace(/\d+/, count);
        });
      })
      .catch(err => {
        console.error('Sepet verisi alınamadı:', err);
      });
  }

  function checkAndSyncCartBubbles() {
    const visibleSpans = Array.from(
      document.querySelectorAll(
        '[data-shogun-cart-items-count] .cart-count-bubble span[aria-hidden="true"]'
      )
    );
    if (visibleSpans.length < 2) return;

    const counts = visibleSpans.map(el => parseInt(el.textContent, 10) || 0);
    const allEqual = counts.every(v => v === counts[0]);

    if (!allEqual) {
      updateAllCartBubbles();
    }
  }

  updateAllCartBubbles();
  checkAndSyncCartBubbles();

  if (window.jQuery) {
    $(document).ajaxComplete((event, xhr, settings) => {
      if (/\/cart\/(add|change)\.js/.test(settings.url)) {
        updateAllCartBubbles();
        checkAndSyncCartBubbles();
      }
    });
  }

  document.addEventListener('ajaxCart:updated', () => {
    updateAllCartBubbles();
    checkAndSyncCartBubbles();
  });

  setInterval(checkAndSyncCartBubbles, 500);
});
